// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 350px;
  height: 400px;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
}

.chat-header {
  background-color: #4BB3BC;
  color: white;
  padding: 10px;
  text-align: center;
}

.chat-body {
  padding: 10px;
}

.toggle-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px;
  /* background-color: #4BB3BC;
  color: white;
  border: none; */
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/AppLayout/Footer/index.css"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,uCAAA;EACA,gBAAA;EACA,2BAAA;EACA,sCAAA;AACJ;;AAEE;EACE,yBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AACJ;;AAEE;EACE,aAAA;AACJ;;AAEE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA;;iBAAA;EAGA,eAAA;AACJ","sourcesContent":[".chat-container {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    width: 350px;\n    height: 400px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n    transform: translateX(100%);\n    transition: transform 0.3s ease-in-out;\n  }\n  \n  .chat-header {\n    background-color: #4BB3BC;\n    color: white;\n    padding: 10px;\n    text-align: center;\n  }\n  \n  .chat-body {\n    padding: 10px;\n  }\n  \n  .toggle-button {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    padding: 10px;\n    /* background-color: #4BB3BC;\n    color: white;\n    border: none; */\n    cursor: pointer;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
